import { render, staticRenderFns } from "./BotSetup.vue?vue&type=template&id=39afcee7&"
import script from "./BotSetup.vue?vue&type=script&lang=js&"
export * from "./BotSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports